import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { fontSize, fontWeight, tertiaryColor } from '@styles/utils';

const FormFieldContainer = styled.div`
  > label {
    display: block;
    padding-bottom: 5px;
    ${fontSize.label};
    font-weight: ${fontWeight.standard};
    color: ${tertiaryColor(700)};

    &[for] {
      cursor: pointer;
    }
  }
`;

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  className?: string;
}

const FormField: FC<PropsWithChildren<FormFieldProps>> = ({ label, htmlFor, required, className, children }) => {
  return (
    <FormFieldContainer className={className}>
      <label htmlFor={htmlFor}>
        {label} {required ? ' *' : null}
      </label>
      {children}
    </FormFieldContainer>
  );
};

export default FormField;
